<template>
  <div class="setting-wrapper"
       id="setting-global">
    <transition name="fade">
      <div class="content-setting"
           v-if="showPopover">
        <el-collapse v-model="activeNames">
          <el-collapse-item :title="$t('resConfig')"
                            :name="1">
            <ResourceConfig :showStaticIp="false"
                            origin="global"/>
          </el-collapse-item>
        </el-collapse>
        <div class="no-collapse">
          <div class="item">
            {{ $t('autoShutIdle') }}
            <el-tooltip effect="dark"
                        popper-class="width215 el-tooltip-border"
                        :content="$t('shutdownTask')"
                        placement="top">
              <div slot="content">{{ $t('autoShutIdleText') }}<br/>{{ $t('shutdownTask') }}</div>

              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
            <el-switch
              v-model="autoShutDown"
              class="f-right"
              active-value="1"
              inactive-value="0"
              active-color="#2FB54E"
              inactive-color="#353535"
              @change="setGroupPreviewSettingFn()">
            </el-switch>
          </div>
        </div>
        <div class="no-collapse">
          <div class="item">
            {{ $t('stopNoNeed') }}
            <el-tooltip effect="dark"
                        popper-class="width215 el-tooltip-border"
                        placement="top">
              <div slot="content">{{ $t('stopNoNeedText') }}<br/>{{ $t('shutdownTask') }}</div>
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
            <el-switch
              v-model="closePreviewWhenNoOutput"
              class="f-right"
              active-value="1"
              inactive-value="0"
              active-color="#2FB54E"
              inactive-color="#353535"
              @change="setGroupPreviewSettingFn()">
            </el-switch>
          </div>
        </div>
        <!-- Audio Sync License 配置项：destination 开启 Audio Sync 时必须设置该 License [Claude Code] -->
        <div class="no-collapse">
          <div class="item">
            {{ $t('audioSyncLicense') }}
            <el-tooltip effect="dark"
                        popper-class="width215 el-tooltip-border"
                        :content="$t('audioSyncLicenseTip')"
                        placement="top">
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
            <el-input
              v-model="wmlicenseKey"
              class="f-right license-input"
              size="small"
              :placeholder="$t('pleaseEnterContent')"
              @blur="setGroupPreviewSettingFn()">
            </el-input>
          </div>
        </div>
      </div>
    </transition>
    <i class="setting-btn el-icon-setting"
       @click="togglePopoverShow"></i>
  </div>
</template>
<script>
import { setGroupSetting } from '@/axios/mediaHub'
import ResourceConfig from './resourceConfig.vue'
import { mapState } from 'vuex'
export default {
  components: {
    ResourceConfig
  },
  data () {
    return {
      activeNames: 1,
      shutDown: false,
      recovery: false,
      groupPreviewInfo: {},
      showPopover: false,
      autoShutDown: '1',
      closePreviewWhenNoOutput: '1',
      // Audio Sync 授权码本地态，默认空字符串 [Claude Code]
      wmlicenseKey: ''
    }
  },
  computed: {
    ...mapState({
      initConfig: state => state.initConfig,
      adminInfo: state => state.adminInfo
    })
  },
  watch: {
    'adminInfo.autoShutDown': {
      handler () {
        this.autoShutDown = this.adminInfo.autoShutDown
      },
      immediate: true
    },
    'adminInfo.closePreviewWhenNoOutput': {
      handler () {
        this.closePreviewWhenNoOutput = this.adminInfo.closePreviewWhenNoOutput
      },
      immediate: true
    },
    // 同步后端 wmlicenseKey 到本地，保持与其他配置项相同范式 [Claude Code]
    'adminInfo.wmlicenseKey': {
      handler () {
        this.wmlicenseKey = this.adminInfo.wmlicenseKey || ''
      },
      immediate: true
    }
  },
  created () {
    // this.getGroupPreviewSettingFn()
  },
  methods: {
    togglePopoverShow (event) {
      // 阻止事件冒泡，防止触发document的click事件
      event.stopPropagation()
      this.showPopover = !this.showPopover
      if (this.showPopover) {
        // 添加点击外部区域隐藏popover的事件监听
        document.addEventListener('click', this.handleClickOutside)
      } else {
        // 移除点击外部区域隐藏popover的事件监听
        document.removeEventListener('click', this.handleClickOutside)
      }
    },
    handleClickOutside (event) {
      // 判断点击事件是否发生在setting-global外部，如果是则隐藏popover
      const settingBox = this.$el // this.$el已经是id为"setting-global"的根元素
      if (settingBox && !settingBox.contains(event.target)) {
        this.showPopover = false
        // 移除点击外部区域隐藏popover的事件监听
        document.removeEventListener('click', this.handleClickOutside)
      }
    },
    setGroupPreviewSettingFn () {
      // 把本地三个配置项一起 PUT 回后端，保持单接口闭环 [Claude Code]
      setGroupSetting({
        groupId: this.initConfig.groupId,
        autoShutDown: this.autoShutDown,
        closePreviewWhenNoOutput: this.closePreviewWhenNoOutput,
        wmlicenseKey: this.wmlicenseKey
      }).then(res => {
      }).catch(() => {})
    }
  },
  beforeDestroy () {
    // 组件销毁时移除点击外部区域隐藏popover的事件监听
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>
<style lang="less" scoped>
.setting-wrapper {
  position: relative;
  .content-setting {
    position: absolute;
    top: 50px;
    left: -205px;
    width: 490px;
    z-index: 1000;
    background-color: #444;
    padding: 8px 12px;
    color: #fff;
    border-radius: 4px;
  }
  .setting-btn {
    cursor: pointer;
    font-size: 18px;
    color: #fff;
  }
  .item {
    margin-bottom: 10px;
    text-align: left;
    line-height: 20px;
    font-size: 14px;
    .res-title {
      color: #dbdbdb;
      margin-bottom: 5px;
      font-weight: 700;
    }
  }
  li {
    cursor: pointer;
  }
  .m-l-10 {
    margin-left: 10px;
  }
  :deep(.el-cascader) {
    .el-input {
      .el-input__inner {
        height: 32px;
        line-height: 32px;
        padding-left: 5px;
        box-sizing: border-box;
        border: 1px solid #353535;
        border-radius: 4px;
        &:focus {
          border: 1px solid @green;
        }
      }
    }
  }
  ::v-deep .el-tabs {
    .el-tabs__header {
      margin-bottom: 0px;
    }
    .el-tabs__nav-wrap {
      &::after {
        background-color: #999;
      }
      .el-tabs__nav {
        .el-tabs__item {
          padding: 0px 20px;
          border-radius: 4px 4px 0px 0px;
          color: #999;
          &:hover {
            background-color: #b0b0b0;
            color: #f0f0f0;
          }
          &.is-active {
            background-color: @green;
            border: 1px solid #f0f0f0;
            color: #f0f0f0;
            &:hover {
              border: 1px solid @green;
              color: #262626;
            }
          }

        }
        .el-tabs__active-bar {
          display: none;
        }
      }
    }
    .el-tab-pane {
      padding-top: 10px;
    }
  }
  .byor-content {
    line-height: 40px;
    color: #ddd;
    a {
      color: @green;
      font-weight: bold;
      text-decoration: none;
    }
  }
  a {
    color: @green;
    font-weight: bold;
  }
  .no-collapse {
    border-top: 1px solid #666;
    margin-top: 10px;
    color: #dbdbdb;
    .item {
      margin-top: 10px;
      i {
        color: #f8f8f8;
        font-size: 16px;
        transform: rotate(180deg);
      }
    }
  }
  // Audio Sync License 输入框：固定宽度并适配深色面板 [Claude Code]
  ::v-deep .license-input {
    width: 150px;
    .el-input__inner {
      height: 28px;
      line-height: 28px;
      background-color: #353535;
      border: 1px solid #666;
      color: #fff;
      &:focus {
        border-color: @green;
      }
    }
  }
  ::v-deep.el-switch {
    .el-switch__core {
      border-color: #666 !important;
      background-color: #444;
    }
    &.is-checked {
      .el-switch__core {
        border-color: @green !important;
        background-color: @green;
      }
    }
  }
  :deep(.el-collapse) {
      border-top: 1px solid #444;
      border-bottom: 1px solid #444;
      .el-collapse-item__header {
        background-color: #444;
        border-bottom-color: #444;
        font-weight: normal;
        font-size: 14px;
        color: #dbdbdb;
        height: 24px;
        line-height: 24px;
      }
      .el-collapse-item__content {
        background-color: #444;
        margin-top: 10px;
        padding-bottom: 0px;
      }
      .el-collapse-item__wrap {
        background-color: #444;
        border-bottom-color: #444;
      }
      .el-collapse-item {
        .el-collapse-item__wrap {
          overflow: auto;
        }
      }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
}

</style>
